import { action, atom, noop, sleep } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { reatomRequest } from '@root/shared/lib'

type CreateCurrencyPayload = {
  readonly avatar: File | undefined
  readonly name: string
  readonly symbol: string
  readonly description: string
  readonly websiteUrl: string
  readonly telegramUrl: string
  readonly xUrl: string
}

// TODO: Ivan - connect to API
const mockRequestAction = action(
  async (ctx, payload: CreateCurrencyPayload) => {
    payload
    await ctx.schedule(() => sleep(1000))
    return Result.succeed(123)
  },
  'mockRequestAction',
)

export const reatomCreateCurrencyForm = () => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const requestState = reatomRequest({
    execAction: mockRequestAction,
  })

  const nameAtom = atom('', 'nameAtom')
  const symbolAtom = atom('', 'symbolAtom')
  const descriptionAtom = atom('', 'descriptionAtom')

  return { requestState, nameAtom, symbolAtom, descriptionAtom }
}
export const openCreateCurrencyModalEvent = action(
  noop,
  'openCreateCurrencyModalEvent',
)
